import type { ReactElement } from 'react'
import { ButtonBack, NotReady, UserInfo } from '@components'
import { useSnapshotEmployees } from '@front/model'
import { Divider, Grid, Group } from '@mantine/core'
import { type UserId, isUserId } from '@terros/common'
import { useRequiredParams } from '@util'
import { useQueryState } from 'nuqs'
import EmployeeList from './EmployeeList'
import SnapshotView from './SnapshotView'
import { createFileRoute } from '@tanstack/react-router'

type Props = {
  managerId: UserId
}

function TaskEmployees(): ReactElement {
  const { managerId } = useRequiredParams<Props>()
  const { data, isLoading, error } = useSnapshotEmployees({ managerId })
  const [selectedUserId, setSelectedUserId] = useQueryState('userId')
  if (isLoading || error || !data) return <NotReady data={data} error={error} id='employees' isLoading={isLoading} />
  const selectedSnapshot = data.find((s) => s.userId === selectedUserId)
  if (!isUserId(managerId)) return <div>Invalid managerId</div>
  return (
    <div>
      <Group pb='sm'>
        <ButtonBack />
        <UserInfo size='md' userId={decodeURIComponent(managerId) as UserId} />
      </Group>
      <Divider pb='sm' />
      <Grid>
        <Grid.Col span={selectedSnapshot ? 4 : 12}>
          <EmployeeList employees={data} selectedUserId={selectedUserId} setSelectedUserId={setSelectedUserId} />
        </Grid.Col>
        {selectedSnapshot && <SnapshotView snapshotFull={selectedSnapshot} />}
      </Grid>
    </div>
  )
}

export const Route = createFileRoute('/task/managers_/$managerId/')({
  component: TaskEmployees,
})
